import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule, PageMetaResolver } from '@spartacus/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { GenSavedAddressesComponent } from './saved-addresses.component';
import { GenSavedAddressItemComponent } from './saved-address-item/saved-address-item.component';
import { GenSavedAddressesPageMetaResolver } from '../../resolvers/saved-addresses-page-meta.resolver';
import { GenEditSavedAddressDialogComponent } from './edit-saved-address-dialog/edit-saved-address-dialog.component';
import { GenDeleteSavedAddressDialogComponent } from './delete-saved-address-dialog/delete-saved-address-dialog.component';
import { GenAddressFormComponent } from '../../shared/components/address-form/address-form.component';

@NgModule({
  declarations: [ 
    GenSavedAddressesComponent,
    GenSavedAddressItemComponent,
    GenEditSavedAddressDialogComponent,
    GenDeleteSavedAddressDialogComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    GenAddressFormComponent,
  ],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: GenSavedAddressesPageMetaResolver,
      multi: true,
    },
  ]
})
export class GenSavedAddressesModule {}
